/**
 * Transforms a ScheduleV2 array into a data structure suitable for rendering
 * recommended time preview rows. Each row provides: day label, start time string, end time string.
 */

import type { ScheduleV2 } from '../../../../../gql/graphql'

export type SchedulePreviewItem = {
  day: string // eg. "Monday"
  startTime: string // eg. "9:00 AM"
  endTime: string // eg. "10:00 AM"
}

function formatTime24ToAmPm(time: string): string {
  // Expects time in "HH:mm" (24h) and returns "h:mm AM/PM"
  const [hourStr, minuteStr] = time.split(':')
  let hour = parseInt(hourStr, 10)
  const minute = parseInt(minuteStr, 10)
  const ampm = hour >= 12 ? 'PM' : 'AM'
  if (hour === 0) hour = 12
  else if (hour > 12) hour -= 12
  return `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`
}

export function transformScheduleIntoPostingTimePreview(
  postingSchedule: ScheduleV2[] = [],
): SchedulePreviewItem[] {
  const previewRows: SchedulePreviewItem[] = []

  // Skip any slot that is paused, has no times, or times array is empty
  postingSchedule
    .filter(
      (slot) =>
        !slot.paused && Array.isArray(slot.times) && slot.times.length > 0,
    )
    .forEach((slot) => {
      slot.times.forEach((time) => {
        const [hourStr] = time.split(':')
        const hour = parseInt(hourStr, 10)
        const startTimeFormatted = formatTime24ToAmPm(`${hourStr}:00`)
        const endHour = (hour + 1) % 24
        const endHourStr = endHour.toString().padStart(2, '0')
        const endTimeFormatted = formatTime24ToAmPm(`${endHourStr}:00`)
        previewRows.push({
          day: slot.day.charAt(0).toUpperCase() + slot.day.slice(1),
          startTime: startTimeFormatted,
          endTime: endTimeFormatted,
        })
      })
    })

  return previewRows
}
